<template>
  <div>
    <div>
      <router-view/>
      <!-- set progressbar -->
      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,300;1,400&display=swap');
@font-face {
  font-family: "Google Sans Regular";
  src: url("./assets/Fonts/GoogleSans-Medium.ttf");
}
@font-face {
  font-family: "Google Sans Medium";
  src: url("./assets/Fonts/GoogleSans-Medium.ttf");
}
@font-face {
  font-family: "Google Sans Bold";
  src: url("./assets/Fonts/GoogleSans-Bold.ttf");
}

::-webkit-scrollbar {
  width: 0.7em;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(63, 61, 61, 0.2);
}

a {
  text-decoration: none;
}
* {
  /* font-family: "Google Sans Regular"; */
  font-family: 'Roboto', sans-serif;

}

.v-btn {
  text-transform: unset !important;
  border-radius: 4px;
  letter-spacing: 0.7px !important;
}

.title {
  font-family: "Google Sans Regular" !important;
}
.table-container {
  border-radius: 8px;
  padding: 25px;
  margin: 50px;
}

.form-container {
  border-radius: 8px;
  padding: 35px;
  margin: 50px;
}
</style>
